/* Human Pro advertorial lander - offer form, gallery, sticky bar. Loaded by sections/hpx-advertorial-listicle.liquid. */
(function(){
  var form=document.getElementById('hplOfferForm'); if(!form) return;
  var vid=document.getElementById('hplVariantId'), sp=document.getElementById('hplSellingPlan');
  function sync(){
    var panel=form.querySelector('.hpl-panel.is-active'); if(!panel) return;
    vid.value=panel.getAttribute('data-variant');
    var plan=panel.querySelector('.hpl-plan.is-active'); var pid=plan?plan.getAttribute('data-plan'):'';
    /* a card may carry its own variant (e.g. sub = 60-cap, one-time = 120-cap); fall back to the panel's */
    if(plan&&plan.getAttribute('data-variant')) vid.value=plan.getAttribute('data-variant');
    if(pid){sp.value=pid;sp.disabled=false;}else{sp.value='';sp.disabled=true;}
    /* Appstle injects its own selling_plan inputs - remove any that are not ours (same rule as hpx-subscription-wire) */
    form.querySelectorAll('input[name="selling_plan"]').forEach(function(i){ if(i!==sp) i.remove(); });
  }
  form.querySelectorAll('.hpl-qty button').forEach(function(b){
    b.addEventListener('click',function(){
      form.querySelectorAll('.hpl-qty button').forEach(function(x){x.classList.remove('is-active');x.setAttribute('aria-selected','false');});
      b.classList.add('is-active');b.setAttribute('aria-selected','true');
      form.querySelectorAll('.hpl-panel').forEach(function(p){p.classList.toggle('is-active',p.getAttribute('data-panel')===b.getAttribute('data-qty'));});
      sync();
    });
  });
  form.querySelectorAll('.hpl-plan input').forEach(function(r){
    r.addEventListener('change',function(){
      var panel=r.closest('.hpl-panel');
      panel.querySelectorAll('.hpl-plan').forEach(function(p){p.classList.remove('is-active');});
      r.closest('.hpl-plan').classList.add('is-active'); sync();
    });
  });
  form.addEventListener('submit',function(e){
    sync();
    /* card without a purchasable variant yet (SKU / plan not created): follow its link instead of posting to the cart */
    var plan=form.querySelector('.hpl-panel.is-active .hpl-plan.is-active');
    if(plan&&(!plan.getAttribute('data-variant'))&&plan.getAttribute('data-link')){ e.preventDefault(); window.location.href=plan.getAttribute('data-link'); }
  },true);
  sync();

  /* gallery */
  var track=document.getElementById('hplTrack'), thumbs=document.getElementById('hplThumbs');
  if(track){
    var slides=track.children, idx=0;
    function go(i){ idx=(i+slides.length)%slides.length; track.scrollTo({left:slides[idx].offsetLeft,behavior:'smooth'}); mark(); }
    function mark(){ if(!thumbs) return; thumbs.querySelectorAll('button').forEach(function(t,i){t.classList.toggle('is-active',i===idx);}); }
    document.querySelectorAll('.hpl-gallery__nav').forEach(function(n){n.addEventListener('click',function(){go(idx+parseInt(n.getAttribute('data-dir'),10));});});
    if(thumbs) thumbs.querySelectorAll('button').forEach(function(t){t.addEventListener('click',function(){go(parseInt(t.getAttribute('data-i'),10));});});
    var st; track.addEventListener('scroll',function(){clearTimeout(st);st=setTimeout(function(){var w=track.clientWidth||1;idx=Math.round(track.scrollLeft/w);mark();},80);});
  }

  /* sticky bar: visible whenever the hero CTA is NOT on screen and the offer block is not in view.
     §117: was "after the hero CTA scrolls out", which left no CTA on the first mobile screen (hero CTA sits at ~y 920
     on a 812px screen). Now the bar shows from load until the hero CTA itself scrolls into view, and again after it.
     §128 (1 Oct 2026, Nils): on mobile (< 860px) the bottom bar covered the page title on the first screen, so there it
     now stays hidden until the hero CTA has scrolled out of view ABOVE the viewport. Desktop keeps the §117 behaviour. */
  var sticky=document.getElementById('hplSticky'), hero=document.getElementById('hplHeroCta'), offer=document.getElementById('offers');
  if(sticky&&hero&&offer&&'IntersectionObserver' in window){
    var heroOff=false, heroPast=false, inOffer=false, mq=window.matchMedia('(max-width:859px)');
    function upd(){ sticky.classList.toggle('is-visible', heroOff && !inOffer && (!mq.matches || heroPast)); }
    new IntersectionObserver(function(e){ heroOff = !e[0].isIntersecting; heroPast = heroOff && e[0].boundingClientRect.top < 0; upd(); }).observe(hero);
    new IntersectionObserver(function(e){ inOffer = e[0].isIntersecting; upd(); },{rootMargin:'0px 0px 0px 0px',threshold:0}).observe(offer);
  }
})();

/* Yuko reviews render into an OPEN shadow root, so theme CSS cannot reach them.
   Inject a small stylesheet into that root once it exists: "Verified Buyer" in brand green.
   §117: the badge icon is a filled rosette with the check cut out (evenodd). Fill only, stroke:none,
   otherwise the stroke closes the cut-out and the badge renders as a green blob. */
(function(){
  var css='.r_pw_r_g_container--review-is-verified,.r_pw_r_g_container--review-is-verified *{color:#1a7a2e !important}'+
          '.r_pw_r_g_container--review-is-verified svg,.r_pw_r_g_container--review-is-verified svg *{fill:#1a7a2e !important;stroke:none !important}'+
          '.r_pw_r_g_container--review-is-verified svg [fill="none"]{fill:none !important}';
  function inject(){
    var w=document.querySelector('.yuko-reviews-product-widget'); if(!w||!w.shadowRoot) return false;
    if(w.shadowRoot.querySelector('#hplYukoStyle')) return true;
    var st=document.createElement('style'); st.id='hplYukoStyle'; st.textContent=css; w.shadowRoot.appendChild(st); return true;
  }
  if(inject()) return;
  var tries=0, t=setInterval(function(){ if(inject()||++tries>60) clearInterval(t); },500);
})();